import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from "@angular/core";
import { Catalog, ProductCollection } from "@cureskin/api-client/src/server-api";
import { CsIconModule } from "@components/icon";
import { ProductJumboComponent } from '../../app/shop/components/product-jumbo/product-jumbo.component';
import { SwiperOptions } from 'swiper/types';
import { SwiperModule } from 'swiper/angular';

@Component({
  selector: "app-product-collection-jumbo",
  imports: [CsIconModule, ProductJumboComponent, SwiperModule],
  templateUrl: "./product-collection-jumbo.component.html",
  standalone: true
})
export class ProductCollectionJumboComponent {
  collection: InputSignal<ProductCollection> = input<ProductCollection>();
  products: InputSignal<Catalog[]> = input<Catalog[]>();
  productInCart: InputSignal<any> = input<any>();
  isInfiniteLoopEnabled: InputSignal<boolean> = input<boolean>(false);
  viewCollection: OutputEmitterRef<string> = output<string>();
  addToCart: OutputEmitterRef<{ product: Catalog; image: HTMLImageElement }> = output<{ product: Catalog; image: HTMLImageElement }>();
  reomveFromCart: OutputEmitterRef<Catalog> = output<Catalog>();
  gotoProduct: OutputEmitterRef<Catalog> = output<Catalog>();

  title: Signal<string> = computed(() => this.collection()?.title);
  name: Signal<string> = computed(() => this.collection()?.name);

  private readonly swiperConfigs = new Map<number, SwiperOptions>();

  removeFromCartAction(product: Catalog): void {
    this.reomveFromCart.emit(product);
  }

  addToCartAction(event: { product: Catalog; image: HTMLImageElement }): void {
    this.addToCart.emit(event);
  }

  getProductCartData(productId: string): { quantity: number } | null {
    if (!this.productInCart()) {
      return null;
    }
    const quantity = this.productInCart()[productId] || 0;
    return quantity > 0 ? { quantity } : null;
  }

  gotoProductAction(product: Catalog): void {
    this.gotoProduct.emit(product);
  }

  getSwiperConfig(index: number = 0): SwiperOptions {
    if (!this.swiperConfigs.has(index)) {
      const config: SwiperOptions = {
        spaceBetween: 16,
        loop: this.isInfiniteLoopEnabled(),
        slidesPerView: 'auto',
        loopedSlides: this.isInfiniteLoopEnabled() ? (this.products()?.length || null) : null,
        initialSlide: 0,
        centeredSlides: false,
        speed: 1000,
        threshold: 5,
      };
      this.swiperConfigs.set(index, config);
      return config;
    }
    return this.swiperConfigs.get(index)!;
  }
}
